import { AlertTriangle, Check, Info, Pencil } from 'lucide-react';
import type { PropertyGroupResponse } from '@/shared/api';
import { CardEditButton, AreaCard } from './AreaCard';

const COUNTRY_NAMES: Record<string, string> = {
  DE: 'Deutschland',
  AT: 'Österreich',
  CH: 'Schweiz',
};

/** Name und Adresse des Objekts; sie gelten für alle seine Apartments. */
export function ObjectAddressCard({
  group,
  onEdit,
}: {
  group: PropertyGroupResponse;
  /** Fehlt ohne Schreibrecht — dann gibt es keinen Bearbeiten-Knopf. */
  onEdit?: () => void;
}) {
  const { address } = group;
  return (
    <AreaCard
      title="Name und Adresse"
      aside={
        onEdit && (
          <CardEditButton
            label="Name und Adresse bearbeiten"
            icon={<Pencil size={14} />}
            onClick={onEdit}
          />
        )
      }
      footer={
        <>
          {group.needsAddressReview ? (
            <p className="text-ink flex items-start gap-2">
              <AlertTriangle size={14} className="text-amber mt-0.5 shrink-0" aria-hidden />
              {group.positionLookupPending
                ? 'Adresse wird geprüft — der Kartendienst sucht die Position.'
                : 'Adresse ungeprüft — Pin unter „Lage“ setzen oder bestätigen.'}
            </p>
          ) : (
            <p className="text-ink flex items-start gap-2">
              <Check size={14} className="text-sage mt-0.5 shrink-0" aria-hidden />
              Adresse geprüft
            </p>
          )}
          <p className="flex items-start gap-2">
            <Info size={14} className="mt-0.5 shrink-0" aria-hidden />
            Gilt für alle Apartments dieses Objekts.
          </p>
        </>
      }
    >
      <p className="text-ink font-medium">{group.name}</p>
      <address className="text-ink mt-1 text-[15px] not-italic leading-relaxed">
        <span className="block">{address.street}</span>
        <span className="block">
          {address.postalCode} {address.city}
        </span>
        <span className="block">{COUNTRY_NAMES[address.countryCode] ?? address.countryCode}</span>
      </address>
    </AreaCard>
  );
}
